export default async function GetItemMaster() {
    let url = window.RealestateService+  `/api/ItemMaster/GetItemMaster`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}